module.exports = __webpack_public_path__ + "static/media/ethernet.82be26be.svg";